import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { cn } from '@shared/utils/utils';

@Component({
  selector: 'app-badge',
  template: `<ng-content />`,
  host: { '[class]': 'classes()' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  variant = input<'default' | 'outline' | 'secondary' | 'destructive' | 'warning'>('default');

  readonly classes = computed(() => {
    const variant = this.variant();
    let variantClass: string;
    if (variant === 'default') {
      variantClass = 'bg-primary text-white';
    } else if (variant === 'secondary') {
      variantClass = 'bg-primary-light text-primary-dark';
    } else if (variant === 'outline') {
      variantClass = 'border border-border text-muted';
    } else if (variant === 'warning') {
      variantClass = 'bg-yellow-100 text-yellow-800';
    } else {
      variantClass = 'bg-red-100 text-red-800';
    }
    return cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors', variantClass);
  });
}
